import React, { useState, useContext } from 'react';
import { Button } from 'primereact/button';
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { Password } from 'primereact/password';
import { InputText } from 'primereact/inputtext';
import * as authService from '../admin/services/authService';
import Swal from "sweetalert2";
import { PairUpWithAuthenticators } from '../components/PairUpWithAuthenticators';
import { ConfirmCode } from '../components/ConfirmCode';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

export function Login() {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { onLogin, setFirstLoginPass } = useContext(AuthContext);

    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });

    const [data2FA, setData2FA] = useState({
        username: '',
        code: '',
    });

    const [verfy2FA, setVerify2FA] = useState({
        success: '',
        requires2FA: '',
    })

    document.title = `Вход`;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleChange2FA = (e) => {
        setData2FA(state => ({
            username: formData.username,
            code: e.target.value
        }));
    };

    const loginKEP = (e) => {
        e.preventDefault();
        setLoading(true);

        const domain = window.location.href.split('/schadm')[0];

        window.location.href = `${domain}/api/Auth/redirectToStampITAdmin`;
    }

    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        authService.login(formData)
            .then(data => {
                setVerify2FA(data)
                setFirstLoginPass(formData.password)
                setLoading(false);

            })
            .catch((error) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: error.message,
                    icon: "warning",
                    button: "Добре",
                });
                setLoading(false);

            });
    }

    const submitVerify2FA = (e) => {
        e.preventDefault();
        setLoading(true);

        const inputData = {
            egn: data2FA.username,
            code: data2FA.code
        }

        authService.verify2FALogin(inputData)
            .then((data) => {
                if (data.role == 'Parent') {
                    let firstRole = data.role;

                    data.role = data.secondRole;
                    data.secondRole = firstRole;
                }

                onLogin(data)
                setLoading(false);

                if (data.firstLogin == false) {
                    navigate('/schadm/');
                } else {
                    navigate('/schadm/firstLogin');
                }

            })
            .catch((err) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: err.message,
                    icon: "error",
                    button: "Добре",
                });
                setLoading(false);

                console.log(err)
            })

    }

    return (
        <main>
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            <div className="container h-100">

                <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className={`${verfy2FA.secretKey ? 'col-lg-6' : 'col-lg-4'} col-md-6 d-flex flex-column align-items-center justify-content-center`}>

                                <div className="card mb-3 w-100">

                                    <div className="card-body">

                                        <div className="pt-4 pb-2">
                                            <h5 class="text-center pb-0 fs-4 use-font" style={{ color: "red" }}>СЛУЖЕБЕН МОДУЛ</h5>
                                            <h5 className="card-title text-center pb-0 fs-4 use-font">Вход в системата</h5>
                                        </div>

                                        {verfy2FA.requires2FA && !verfy2FA.secretKey
                                            ? <ConfirmCode
                                                verfy2FA={verfy2FA}
                                                data2FA={data2FA}
                                                handleChange2FA={handleChange2FA}
                                                submitVerify2FA={submitVerify2FA}
                                                isInAdmin={true}
                                            />
                                            : verfy2FA.secretKey && verfy2FA.qrCodeUri
                                                ? <PairUpWithAuthenticators
                                                    username={formData.username}
                                                    verfy2FA={verfy2FA}
                                                    data2FA={data2FA}
                                                    handle2FAChange={handleChange2FA}
                                                    submitVerify2FA={submitVerify2FA}
                                                    isInAdmin={true }
                                                />

                                                : <form className="row g-3 needs-validation justify-content-center" novalidate>

                                                    <div className="form-group">
                                                        <div className="d-flex flex-wrap gap-3">
                                                            <span className="p-float-label labels">
                                                                <InputText name='username' id="username" style={{ width: '100%' }} value={formData.username} onChange={handleChange} />
                                                                <label htmlFor="username">Потребителско име*</label>
                                                            </span>
                                                            <span className="p-float-label labels">
                                                                <Password
                                                                    inputId="pass"
                                                                    name='password'
                                                                    value={formData.password}
                                                                    onChange={handleChange}
                                                                    feedback={false}
                                                                    toggleMask
                                                                    className={`${formData.password.length > 5 || formData.password === '' ? '' : 'p-invalid'} w-100`}
                                                                />
                                                                <label htmlFor="pass">Парола*</label>
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="form-group d-flex flex-wrap justify-content-center items-center">
                                                        <Button
                                                            label="Вход с парола"
                                                            severity="danger"
                                                            raised
                                                            className='btn-prim mt-4 w-100 w-100-mob'
                                                            onClick={onSubmit}
                                                        />
                                                        <p className='w-100 m-0 mt-3 text-center fw-bolder'>ИЛИ</p>
                                                        <Button
                                                            label="Вход с електронен подпис"
                                                            severity="danger"
                                                            raised
                                                            className='btn-prim mt-3 w-100 w-100-mob'
                                                            onClick={loginKEP}
                                                        />
                                                        <p className='w-100 text-start mt-4'>Използването на електронен подпис за вход предоставя най-високо ниво на сигурност и елиминира необходимостта от двуфакторно удостоверяване.</p>

                                                    </div>

                                                </form>
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </section>

            </div>
        </main>
    );
}

export default Login;